export default "__VITE_ASSET__GY7Ujyvp__"